export default typeof self !== 'undefined' && self.atob
    ? self.atob.bind(self)
    : // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
        function (str) { return global.Buffer.from(str, 'base64').toString('utf8'); };
